import { generateQuery, generateURLWithParams } from 'utils';
import http from 'utils/http';

export const fetchAllCustomers = (query) => {
  const url = generateURLWithParams('v1/organizations/{{organizationId}}/customers/', query);
  return http.get(url);
};

export const fetchCustomers = ({ searchKey, page = 1, status }) => {
  const query = generateQuery([
    searchKey ? `search=${encodeURIComponent(searchKey)}` : '',
    page > 1 ? `page=${page}` : '',
    status ? `status=${status}` : '',
  ]);
  return http
    .get(`v1/organizations/{{organizationId}}/customers/${query}`)
    .then((res) => res.data);
};

export const getCustomerById = (customerId) => http
  .get(`v1/organizations/{{organizationId}}/customers/${customerId}`)
  .then((res) => res.data);

export const updateCustomer = (customerId, data) => http
  .patch(`v1/organizations/{{organizationId}}/customers/${customerId}/`, data)
  .then((res) => res.data);

export const getCustomerOrdersById = (customerId, page, params = {}) => {
  const queryParts = [
    page > 1 ? `page=${page}` : '',
    params.page_size ? `page_size=${params.page_size}` : '',
    params.has_coupon ? 'has_coupon=true' : '',
  ];
  const query = generateQuery(queryParts);
  return http
    .get(
      `v1/organizations/{{organizationId}}/customers/${customerId}/orders/${query}`,
    )
    .then((res) => res.data);
};

export const getCustomerActivities = (customerId, params = {}) => {
  const query = generateQuery([
    params.page > 1 ? `page=${params.page}` : '',
    params.page_size ? `page_size=${params.page_size}` : '',
  ]);
  return http
    .get(`v1/organizations/{{organizationId}}/customers/${customerId}/activities/${query}`)
    .then((res) => res.data);
};

export const createCustomerNote = (customerId, data) => http
  .post(`v1/organizations/{{organizationId}}/customers/${customerId}/notes/`, data)
  .then((res) => res.data);

export const createCustomerCall = (customerId, data) => http
  .post(`v1/organizations/{{organizationId}}/customers/${customerId}/calls/`, data)
  .then((res) => res.data);

export const createCustomerEmail = (customerId, data) => http
  .post(`v1/organizations/{{organizationId}}/customers/${customerId}/emails/`, data)
  .then((res) => res.data);

export const createCustomerText = (customerId, data) => http
  .post(`v1/organizations/{{organizationId}}/customers/${customerId}/texts/`, data)
  .then((res) => res.data);
export const addAddressToCustomer =
  ({
    title,
    address,
    latitude,
    longitude,
    details,
    delivery_instructions,
    customer,
    city,
    state,
    country,
    country_code,
    zip_code,
  }) => {
    const payLoad = {
      latitude,
      longitude,
      details,
      delivery_instructions,
      address,
      customer,
      city: city || '',
      state: state || '',
      country: country || '',
      country_code: country_code || '',
      zip_code: zip_code || '',
    };
    if (title) payLoad.title = title.slice(0, 50);
    return http
      .post(
        `v1/organizations/{{organizationId}}/customers/${customer}/addresses/`,
        payLoad,
      )
      .then((res) => res.data);
  };
export const createCustomer =
  ({ name, phone, email }) => {
    const payLoad = {
      name,
      phone,
      email,
    };
    if (name) payLoad.name = name.slice(0, 50);
    return http
      .post('v1/organizations/{{organizationId}}/customers/', payLoad)
      .then((res) => res.data);
  };
